import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formatea un porcentaje con máximo 1 decimal
 * @param value - El valor numérico del porcentaje
 * @returns El porcentaje formateado como string
 */
export function formatPercentage(value: number): string {
  return value.toFixed(1);
}

/**
 * Calcula el porcentaje de cambio entre dos valores
 * @param current - Valor actual
 * @param previous - Valor anterior
 * @returns El porcentaje de cambio formateado
 */
export function calculatePercentageChange(current: number, previous: number): string {
  if (previous === 0) return '0.0';
  const change = ((current - previous) / previous) * 100;
  return formatPercentage(change);
}

